import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CustomersService from "../../api/customers";


export const getCustomers = createAsyncThunk(
  "customers/get",
  async (args, thunkAPI) => {
    try {
      const response = await CustomersService.getCustomers(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCustomerDetail = createAsyncThunk(
  "customerDetail/get",
  async (args, thunkAPI) => {
    try {
      const response = await CustomersService.getCustomerDetail(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createCustomer = createAsyncThunk(
  "customerDetail/post",
  async ({ args }, thunkAPI) => {
    try {
      const response = await CustomersService.createCustomer(args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);


export const updateCustomer = createAsyncThunk(
  "customerDetail/patch",
  async ({ customerId, args }, thunkAPI) => {
    try {
      const response = await CustomersService.updateCustomer(customerId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addPaymentMethod = createAsyncThunk(
  "customer/addPayment",
  async ({ customerId, args }, thunkAPI) => {
    try {
      const response = await CustomersService.addPaymentMethod(customerId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addSubscription = createAsyncThunk(
  "customer/addSubscription",
  async ({ customerId, args }, thunkAPI) => {
    try {
      const response = await CustomersService.addSubscription(customerId, args);
      //thunkAPI.dispatch(setMessage(response.data.message));
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data) ||
        error.message ||
        error.toString();
      //thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);


const initialState = {
  results: [],
  count: 0,
  next: null,
  previous: null,
  selectedCustomer: null,
  error: null,
  loading: false,
  loadingDetail: false,
  loadingUpdate: undefined
};

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    clearSelectedCustomer: (state, action) => {
      state.selectedCustomer = null;
    }
  },
  extraReducers: {
    [getCustomers.pending]: (state, action) => {
      state.loading = true;
    },
    [getCustomers.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
      state.loading = false
    },
    [getCustomers.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja viðskiptavini";
    },
    [getCustomerDetail.pending]: (state, action) => {
      state.loadingDetail = true;
    },
    [getCustomerDetail.fulfilled]: (state, action) => {
      state.selectedCustomer = action.payload;
      state.loadingDetail = false
    },
    [getCustomerDetail.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja viðskiptavin";
    },
    [updateCustomer.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [updateCustomer.fulfilled]: (state, action) => {
      state.selectedCustomer = Object.assign(state.selectedCustomer, action.payload);
      let oldCustomerList = state.results;
      let oldSelectedCustomerIndex = oldCustomerList.findIndex(customer => customer.id === state.selectedCustomer.id);
      if (oldSelectedCustomerIndex > -1) {
        oldCustomerList[oldSelectedCustomerIndex] = Object.assign(oldCustomerList[oldSelectedCustomerIndex], state.selectedCustomer)
        state.results = oldCustomerList;
      }
      state.loadingUpdate = false;
    },
    [updateCustomer.rejected]: (state, action) => {
      state.error = "Ekki tókst að búa til viðskiptavin";
      state.loadingUpdate = false;
    },
    [createCustomer.pending]: (state, action) => {
      state.loadingUpdate = true;
    },
    [createCustomer.fulfilled]: (state, action) => {
      state.selectedCustomer = Object.assign(state.selectedCustomer || {}, action.payload);
      state.loadingUpdate = false;
    },
    [createCustomer.rejected]: (state, action) => {
      state.error = "Ekki tókst að uppfæra viðskiptavin";
      state.loadingUpdate = false;
    },
  },
});

const { reducer } = customersSlice;
export default reducer;

export const { clearSelectedCustomer } = customersSlice.actions